var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1385_47590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 18.5087C21.8404 19.5563 20.4792 20.4159 19.0298 21.0722L17.7305 17.3357H19.576V16.6315C19.576 14.4154 17.7731 12.6125 15.557 12.6125H9.07302L8.64763 11.2039H14.8875V9.79542H8.22233L6.01948 2.50127L6.00776 2.46245L5.99159 2.42519C5.55832 1.42417 4.75872 0.658041 3.74003 0.268133C2.72134 -0.121728 1.61457 -0.0854467 0.623581 0.370415L0.0711096 0.624525L4.96943 17.3356H6.39926L5.09491 21.1287C3.59847 20.4657 2.19427 19.5864 0.932254 18.5086L0.0175781 19.5796C3.35519 22.4302 7.61051 24 11.9997 24C16.3888 24 20.6442 22.4302 23.9818 19.5796L23.067 18.5087ZM11.9996 22.5915C10.082 22.5916 8.19209 22.2667 6.40638 21.6461L7.88862 17.3356H16.2392L17.722 21.6C15.8984 22.2503 13.9636 22.5915 11.9996 22.5915Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1385_47590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotm);
export default __webpack_public_path__ + "static/media/NOTM.e7e662ceca58b0a25dede2add56b3603.svg";
export { ForwardRef as ReactComponent };